import React from 'react';
import { createRoot } from 'react-dom/client';

import shouldPolyfill from './polyfills/should';

function getAppProps() {
    return window.props || {};
}

// The server renders these tags for crawlers without JavaScript, and PageMeta renders them again with
// react-helmet-async, which adds its own under React 19 instead of taking over the server's
const SERVER_META_SELECTOR = [
    'title',
    'meta[name="description"]',
    'meta[name="keywords"]',
    'meta[name="twitter:card"]',
    'meta[property="og:title"]',
    'meta[property="og:description"]',
    'meta[property="og:image"]',
    'meta[property="og:url"]',
].join(',');

function renderApp(Container, props) {
    if (!props.isPanneau) {
        document.head.querySelectorAll(SERVER_META_SELECTOR).forEach((tag) => tag.remove());
    }
    const element = document.getElementById('app');
    const container = React.createElement(Container, props);
    const strictMode = React.createElement(React.StrictMode, {}, container);
    const root = createRoot(element);
    root.render(strictMode);
}

function loadContainer({ isPanneau = false }) {
    return isPanneau
        ? import('./components/Panneau').then(({ default: Container }) => Container)
        : import('./components/App').then(({ default: Container }) => Container);
}

const props = getAppProps();

if (shouldPolyfill()) {
    import('./polyfills/index')
        .then(() => loadContainer(props))
        .then((Container) => renderApp(Container, props));
} else {
    loadContainer(props).then((Container) => renderApp(Container, props));
}
